<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><a id="page_vii">Contents</a></span></p><a id="page_vii">
</a><p class="toc-entry"><a id="page_vii"></a><a href="#/Book1/xhtml/fm01">Preface</a></p>
<p class="toc-entry1"><a href="#/Book1/xhtml/chapter01">Chapter   1  <i>Who Are We?</i></a></p>
<p class="toc-entry1"><a href="#/Book1/xhtml/chapter02">Chapter   2  <i>Bloody Waters</i>—<i>Tarawa and Normandy</i></a></p>
<p class="toc-entry1"><a href="#/Book1/xhtml/chapter03">Chapter   3  <i>From Saipan to Tokyo Bay</i></a></p>
<p class="toc-entry1"><a href="#/Book1/xhtml/chapter04">Chapter   4  <i>A Different Breed</i>—<i>Commandos from the Sea</i></a></p>
<p class="toc-entry1"><a href="#/Book1/xhtml/chapter05">Chapter   5  <i>New Horizons</i>—<i>and War in Korea</i></a></p>
<p class="toc-entry1"><a href="#/Book1/xhtml/chapter06">Chapter   6  <i>Birth of the SEALs</i></a></p>
<p class="toc-entry1"><a href="#/Book1/xhtml/chapter07">Chapter   7  <i>A Pleasant Little War</i></a></p>
<p class="toc-entry1"><span href="#/Book1/xhtml/chapter08" title="Link target outside of Sample">Chapter   8  <i>The Men with Green Faces</i></span></p>
<p class="toc-entry1"><span href="#/Book1/xhtml/chapter09" title="Link target outside of Sample">Chapter   9  <i>The Super SEALs</i></span></p>
<p class="toc-entry1"><span href="#/Book1/xhtml/chapter10" title="Link target outside of Sample">Chapter 10  <i>The Lieutenant (jg) Says No</i></span></p>
<p class="toc-entry1"><span href="#/Book1/xhtml/chapter11" title="Link target outside of Sample">Chapter 11  <i>The March of the Jedi</i></span></p>
<p class="toc-entry1"><a id="page_viii"></a><span href="#/Book1/xhtml/chapter12" title="Link target outside of Sample">Chapter 12  <i>A Tiny Little Island</i></span></p>
<p class="toc-entry1"><span href="#/Book1/xhtml/chapter13" title="Link target outside of Sample">Chapter 13  <i>Target: Manuel Noriega</i></span></p>
<p class="toc-entry1"><span href="#/Book1/xhtml/chapter14" title="Link target outside of Sample">Chapter 14  <i>To the Persian Gulf</i>—<i>and Beyond</i></span></p>
<p class="toc-entry1-1"><span href="#/Book1/xhtml/endmatter01" title="Link target outside of Sample">Image Gallery</span></p>
<p class="toc-entry1-1"><span href="#/Book1/xhtml/endmatter02" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc-entry1-1"><span href="#/Book1/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?430643c3